<template>
  <div class="flex items-center justify-between bg-gray-900 text-white">
    <!-- Title -->
    <h1 class="flex flex-1 items-center py-1 px-2 text-lg font-bold uppercase" style="line-height: 0">
      <img class="h-8" src="../assets/logo.png" alt />
      <span class="hidden ml-2 sm:inline">Diabotical</span>
      <span class="mx-2">Streamers</span>
    </h1>

    <!-- Autoopen -->
    <!-- <img class="h-6 -my-1 mr-4" src="../assets/process.svg" alt="" /> -->
    <!-- <i class="fa fa-external-link-alt mr-4 cursor-pointer text-xl" :class="config.autoOpen ? 'enabled' : 'disabled'" @click="config.autoOpen = !config.autoOpen" /> -->

    <!-- Status -->
    <div class="mr-6">
      <div class="hidden sm:block">{{ myAvatars.length }} of {{ channels.length }}<span class="hidden md:inline"> avatars</span> ({{ ownedPercent }}%)</div>
      <div class="block sm:hidden">{{ ownedPercent }}%</div>
      <div class="mt-1 h-1 rounded overflow-hidden bg-gray-700" style="width-full">
        <div class="h-1  bg-green-600" :style="{ width: ownedPercent + '%' }"></div>
      </div>
    </div>

    <!-- Buttons -->
    <div
      class="relative flex items-center self-stretch px-6 cursor-pointer text-white bg-gradient-to-br hover:bg-opacity-25 uppercase"
      :class="config.autoOpen ? 'from-green-600 to-green-800 hover:from-green-500' : 'from-red-600 to-red-800 hover:from-red-500'"
      title="Auto open streams with new avatars"
      @click="config.autoOpen = !config.autoOpen"
    >
      <img class="w-6" src="../assets/watching.gif" alt="" v-show="config.autoOpen" />
      <i class="fa fa-external-link-alt w-6 text-xl" v-if="!config.autoOpen" />
      <span class="hidden md:inline ml-3">Auto open</span>
    </div>

    <!-- <div class="relative flex items-center self-stretch px-6 cursor-pointer text-white bg-gradient-to-br from-gray-600 to-gray-800 hover:from-gray-500 hover:bg-opacity-25 uppercase" @click="config.settings = !config.settings">
      <i class="fa fa-cog text-xl" /><span class="hidden md:inline ml-3">Settings</span>
    </div> -->

    <div class="relative self-stretch select-none">
      <div class="z-30 absolute top-full right-0 min-w-full overflow-hidden" v-show="settingsDropdown">
        <Settings :class="{ '-translate-y-full': !settingsDropdown }" />
      </div>
      <div class="relative flex items-center self-stretch h-full px-6 cursor-pointer text-white bg-gradient-to-br from-gray-600 to-gray-800 hover:from-gray-500 hover:bg-opacity-25 uppercase" @click.stop="settingsDropdown = !settingsDropdown">
        <i class="fa fa-cog text-xl" /><span class="hidden md:inline ml-3">Settings</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { config, channels, myAvatars } from '@/store'
  import { computed, ref } from 'vue'
  import Settings from '@/components/Settings'

  export default {
    name: 'MainMenu',
    components: {
      Settings,
    },
    setup() {
      const ownedPercent = computed(() => Math.round((100 * myAvatars.value.length) / (channels.value.length || 1)))
      const settingsDropdown = ref(false)
      return {
        config,
        myAvatars,
        channels,
        ownedPercent,
        settingsDropdown,
      }
    },
  }
</script>

<style>
  .enabled {
    color: #0c0;
  }
  .disabled {
    color: #c00;
  }
</style>
